import React from "react";
import { Link } from "react-router-dom";
import { artists, explore } from "../../route-link";
import NotificationTime from "./NotificationTime";
import NotificationImage from "./NotificationImage";
import Spider from "../../assets/images/spider.jpeg";
import { IArtwork } from "../../types/artwork/artwork";
import { IImage } from "../../types/imageData";

interface SubmitArtworkNotificationProps {
  nameFrom: string;
  userId: string;
  artwork: IArtwork;
  time: Date;
  userImage: IImage;
}

const SubmitArtworkNotification: React.FC<SubmitArtworkNotificationProps> = ({
  nameFrom,
  userId,
  time,
  artwork,
  userImage,
}): JSX.Element => {
  const authUserId = localStorage.getItem("myMOCAId") || "";
  const imageSrc = artwork?.image?.thumbnail.url || Spider;
  const artworkId = artwork?._id;
  return (
    <div className="notification_grid">
      <p className="notification_text">
        <Link
          className="notification_link"
          to={`${explore}/${artists}/${userId}`}
          state={{ name: nameFrom, image: userImage }}
        >
          {nameFrom}
        </Link>{" "}
        submitted a suggestion for artwork uploaded by{" "}
        <Link className="notification_link" to={`${explore}/${artists}/${authUserId}`}>
          You
        </Link>
      </p>
      <NotificationTime time={time} />
      <Link to={`${explore}/${artworkId}`}>
        <NotificationImage imageSrc={imageSrc} alt="Artwork" />
      </Link>
    </div>
  );
};

export default SubmitArtworkNotification;
